import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ScreenSizeService implements OnInit{
  private screenWidth = new BehaviorSubject<number>(window.innerWidth);
  screenWidth$ = this.screenWidth.asObservable();

  constructor(private router: Router) {

  }

ngOnInit(): void {
        // Initial check when the service is initialized
        this.checkViewportWidth();

        // Add an event listener for resize to trigger viewport updates
        window.addEventListener('resize', () => this.checkViewportWidth());
        window.addEventListener('popstate', () => this.checkViewportWidth());
    
        // Re-check viewport width on each navigation end
        this.router.events.subscribe(event => {
          if (event instanceof NavigationEnd) {
            this.checkViewportWidth();
          }
        });
}

  public checkViewportWidth() {
    const newWidth = window.innerWidth;
    if (this.screenWidth.value !== newWidth) {
      this.screenWidth.next(newWidth);
    }
  }
}
